<app-loader [Parent]="this"></app-loader>
@if (Model != null) {
  <form #form>
    <app-pageheader [Parent]="this">
      @if (ModelIsNew==false) {
        <app-form-delete-button [Parent]="this" [Model]="Model" DeleteUrl="parking/ratesets/"
        DeleteNavLink="parking/rates/ratesets" [DeleteCheck]="true" Api="parking" TypeName="ParkingRateSet"></app-form-delete-button>
      }
      <app-form-save-button [Parent]="this" [Form]="form" (OnSave)="Save()">Save</app-form-save-button>
    </app-pageheader>
    <app-field Label="Name">
      <div class="control">
        <input name="Name" class="input" type="text" [(ngModel)]="Model.Name" required />
        <app-validator [For]="form['Name']" [ErrorDefs]="{ 'valueMissing' : 'Name is required' }">
        </app-validator>
      </div>
    </app-field>
    <app-field Label="Customer Group" tippy="Customer group for sessions using this rate set (used as fallback when permit/validation don't specify one)">
      <div class="control">
        @if (CustomerGroups != null) {
          <div class="select">
            <select name="CustomerGroupId" class="input" [(ngModel)]="Model.CustomerGroupId">
              <option value="">None</option>
              @for (cg of CustomerGroups; track cg) {
                <option [ngValue]="cg.Id">{{cg.Name}}</option>
              }
            </select>
          </div>
        }
        @if (CustomerGroups == null) {
          <span>
            Loading...
          </span>
        }
      </div>
    </app-field>
    <app-field Label="Multi-Day Parking" tippy="Enable to allow parking sessions to span multiple days">
      <div class="field has-addons">
        <div class="control">
          <label class="checkbox" style="display: flex; align-items: center; height: 100%; padding: 0 0.75em; border: 1px solid #dbdbdb; border-radius: 4px 0 0 4px; background-color: white;">
            <input name="AllowMultiDay" type="checkbox" [(ngModel)]="Model.AllowMultiDay" style="margin-right: 0.5em;" />
            <span>Allow Multi-Day</span>
          </label>
        </div>
        @if (Model.AllowMultiDay) {
          <div class="control">
            <input name="MultiDayMaximumDays" class="input" type="number" [(ngModel)]="Model.MultiDayMaximumDays" min="1" max="365" placeholder="Days" style="width: 100px;" />
          </div>
        }
        @if (Model.AllowMultiDay) {
          <div class="control">
            <a class="button is-static">
              Days Maximum
            </a>
          </div>
        }
      </div>
    </app-field>
    <app-tabs #tabsComponent (SelectedIndexChanged)="TabChanged($event)" [AllowInsertRequest]="true"
      (TabInsertRequested)="SplitPeriod($event)">
      @for (p of Grids; track trackByPeriod(pIndex, p); let pIndex = $index) {
        <app-tab
          Title="{{p.Period.StartDay}} {{calendarService.GetMonth(p.Period.StartMonth).ShortName}} to {{p.Period.EndDay}} {{calendarService.GetMonth(p.Period.EndMonth).ShortName}}">
          <div class="columns is-gapless">
            <div class="column is-10 calendar">
              <div class="timecolumn">
                @for (h of TimeHeaders; track h) {
                  <div class="timelabel" [ngStyle]="{ 'height' : SlotHeight + 'px'}">
                    <span class="time">{{h}}</span>
                  </div>
                }
              </div>
              @for (day of p.Days; track day; let dIndex = $index) {
                <div class="daycolumn" style="position: relative;"
                  (mousemove)="ColumnMouseMove($event)" (mouseup)="EndDrag($event)" (mouseleave)="CancelDrag($event)">
                  <div class="colhead">
                    <div style="padding-left: 2em; margin-bottom: 4px;">{{day.Header}}
                      <button class="button is-default is-small addsplitbutton" (click)="AddTrack(day)">
                        <i class="fa fa-plus"></i>
                        Add Split
                      </button>
                    </div>
                  </div>
                  <div class="columns is-gapless">
                    @for (track of day.Tracks; track track) {
                      <div [class]="'column is-' + (12/day.Tracks.length)" style="position: relative; ">
                        @for (slot of track.Slots; track slot) {
                          <div class="slot" [ngStyle]="{ 'height' : SlotHeight + 'px'}"
                            (click)="EmptySlotClicked(slot, track)">
                          </div>
                        }
                        @for (t of track.Timespans; track t; let tIndex = $index) {
                          <div class="timespan {{t.TextClass}}"
                            [ngClass]="{ 'is-dragging': t == CurrentResizeTimeSpan }"
                            [ngStyle]="{ top: t.Top + 'px', 'height': t.Height + 'px', 'background': t.PriceRuleColor}">
                            <div class="has-text-centered">
                              {{t.PriceRuleName}}
                              <span (click)="DeleteTimespan(track, tIndex)" style="cursor: pointer;">
                                <i class="fa fa-trash"></i>
                              </span>
                            </div>
                            <div class="has-text-centered">
                              {{t.StartHour}}:{{(t.StartMinute < 10 ? '0' : '' ) + t.StartMinute}} -
                              {{t.EndHour}}:{{(t.EndMinute < 10 ? '0' : '' ) + t.EndMinute}}
                            </div>
                            <div class="has-text-left pl-3" tippy="Blocks that follow directly on from the previous block and have the same price rule will be considered a single continuous block. Enabling this option forces this block to not merge with the prior block even if they have the same price rule.">
                              <input type="checkbox" [(ngModel)]="t.DisableMergePrior" [name]="'DisableMergePrior_'+pIndex+'_'+dIndex+'_'+tIndex" style="vertical-align: middle;">
                              <label> Do not merge with previous</label>
                            </div>
                            <div class="has-text-left pl-3" tippy="If enabled then the block acts as a 'No Parking' block but will continue to charge any existing sessions according to the selected price rule.">
                              <input type="checkbox" [(ngModel)]="t.DenyEntry" [name]="'DenyEntry_'+pIndex+'_'+dIndex+'_'+tIndex" style="vertical-align: middle;">
                              <label> Deny New Entries</label>
                            </div>
                            <div class="has-text-left pl-3" tippy="When enabled, fee quoting and rating stop after this block for the current calculation (same as hitting a no-parking rule for iteration, but without blocking parking). If blocks merge, stopping applies if any merged block has this set.">
                              <input type="checkbox" [(ngModel)]="t.IsFinalSpanForIteration" [name]="'IsFinalSpanForIteration_'+pIndex+'_'+dIndex+'_'+tIndex" style="vertical-align: middle;">
                              <label> Break at End</label>
                            </div>
                            <div class="draghandlebottom" (mousedown)="StartDrag($event, 'bottom', t, track)"
                              (mouseup)="EndDrag($event)">
                            </div>
                            <div class="draghandletop" (mousedown)="StartDrag($event, 'top', t, track)"
                              (mouseup)="EndDrag($event)">
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
              <div class="column is-1">
              </div>
              <div class="column is-2">
              </div>
            </div>
            <div class="column is-2">
              <div class="field pl-5" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
                @if (Grids.length > 1) {
                  <div class="select is-small">
                    <select (change)="CopyFromPeriod(pIndex, $event)">
                      <option value="">Copy from...</option>
                      @for (g of Grids; track g; let gIndex = $index) {
                        <option
                          [value]="gIndex"
                          [disabled]="gIndex === pIndex">
                          {{g.Period.StartDay}} {{calendarService.GetMonth(g.Period.StartMonth).ShortName}} to {{g.Period.EndDay}} {{calendarService.GetMonth(g.Period.EndMonth).ShortName}}
                        </option>
                      }
                    </select>
                  </div>
                }
                @if (Grids.length > 1) {
                  <button class="button is-danger is-small"
                    (click)="DeletePeriod(pIndex)"
                    >
                    <i class="fa fa-trash"></i>
                  </button>
                }
              </div>
              <div class="field pl-5">
                <label class="label">Starts</label>
                <div class="field-body">
                  <div class="field has-addons">
                    <div class="control">
                      <div class="select">
                        <select [name]="'StartDay'+pIndex" [(ngModel)]="p.Period.StartDay"
                          (change)="PeriodChanged(p.Period, pIndex)" [disabled]="pIndex == 0">
                          @for (i of calendarService.GetIntArrayForMonth(p.Period.StartMonth); track i) {
                            <option
                            [ngValue]="i">{{i}}</option>
                          }
                        </select>
                      </div>
                    </div>
                    <div class="control">
                      <div class="select">
                        <select [name]="'StartMonth'+pIndex" [(ngModel)]="p.Period.StartMonth"
                          (change)="PeriodMonthChanged(p.Period, pIndex)"
                          [disabled]="pIndex == 0">
                          @for (i of calendarService.GetMonthArray(); track i) {
                            <option
                            [ngValue]="i.Index">{{i.Name}}</option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="field pl-5">
                <label class="label">Ends</label>
                <div class="field-body">
                  <div class="field has-addons">
                    <div class="control">
                      <div class="select">
                        <select [name]="'EndDay'+pIndex" [(ngModel)]="p.Period.EndDay"
                          (change)="PeriodChanged(p.Period, pIndex)"
                          [disabled]="pIndex == Grids.length - 1">
                          @for (i of calendarService.GetIntArrayForMonth(p.Period.EndMonth); track i) {
                            <option
                            [ngValue]="i">{{i}}</option>
                          }
                        </select>
                      </div>
                    </div>
                    <div class="control">
                      <div class="select">
                        <select [name]="'EndMonth'+pIndex" [(ngModel)]="p.Period.EndMonth"
                          (change)="PeriodMonthChanged(p.Period, pIndex)"
                          [disabled]="pIndex == Grids.length - 1">
                          @for (i of calendarService.GetMonthArray(); track i) {
                            <option
                            [ngValue]="i.Index">{{i.Name}}</option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="is-size-4 has-text-centered mt-2">Price Rules</div>
              <div style="max-height: 30em; overflow-y: scroll;">
                <table class="table is-striped is-bordered is-fullwidth">
                  <tbody>
                    @for (p of PriceRules; track p) {
                      <tr class="pricerule" (click)="SelectPriceRule(p)"
                        [ngClass]="{ 'is-selected' : p.Selected }">
                        <td class="swatch" [ngStyle]="{'background' : p.Color }"></td>
                        <td class="name">{{p.Name}}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </app-tab>
      }
    </app-tabs>
  </form>
}